import { Context, Schema } from "effect";

export class WidgetTeam extends Schema.Class<WidgetTeam>("WidgetTeam")({
  _id: Schema.String,
  name: Schema.String,
  createdAt: Schema.Date,
}) {}

export class CurrentWidget extends Context.Tag("CurrentWidget")<
  CurrentWidget,
  WidgetTeam
>() {}

export class WidgetCustomer extends Schema.Class<WidgetCustomer>(
  "WidgetCustomer",
)({ _id: Schema.String, email: Schema.String }) {}

export class WidgetAuthContext extends Schema.Class<WidgetAuthContext>(
  "WidgetAuthContext",
)({ team: WidgetTeam, customer: WidgetCustomer }) {}

export class CurrentWidgetCustomer extends Context.Tag("CurrentWidgetCustomer")<
  CurrentWidgetCustomer,
  WidgetAuthContext
>() {}
